import { classNames } from "primereact/utils";

import { Dropdown } from "@/ds";
import {
  PROFISSIONAL_SELECT_ALTURA_LISTA,
  PROFISSIONAL_SELECT_FILTER_PLACEHOLDER,
} from "./profissional-select.constants";
import styles from "./profissional-select.module.scss";
import type { ProfissionalOpcao, ProfissionalSelectViewModel } from "./types-profissional-select";

const PT = {
  filterInput: { className: styles.filtro },
};

/** Select de profissional com busca por nome ou e-mail (mesmo seletor da etapa Equipe da Nova Obra). */
export function ProfissionalSelectView({ vm }: { vm: ProfissionalSelectViewModel }) {
  return (
    <Dropdown
      id={vm.id}
      name={vm.name}
      className={classNames(styles.select, vm.className)}
      pt={PT}
      scrollHeight={PROFISSIONAL_SELECT_ALTURA_LISTA}
      panelClassName={styles.painel}
      value={vm.value}
      options={vm.options}
      optionLabel="label"
      optionValue="value"
      filter
      filterBy="label,email"
      filterPlaceholder={PROFISSIONAL_SELECT_FILTER_PLACEHOLDER}
      placeholder={vm.placeholder}
      emptyFilterMessage={vm.emptyFilterMessage}
      emptyMessage={vm.emptyMessage}
      disabled={vm.disabled}
      invalid={vm.invalid}
      aria-label={vm.ariaLabel}
      aria-describedby={vm.ariaDescribedBy}
      data-testid={vm.testId}
      itemTemplate={(opcao: ProfissionalOpcao) => (
        <span className={styles.opcao}>
          <span className={styles.opcaoNome}>{opcao.label}</span>
          <span className={styles.opcaoEmail}>{opcao.email}</span>
        </span>
      )}
      onChange={(event) => vm.selecionar(event.value as string | null | undefined)}
    />
  );
}
